import { createFileRoute } from '@tanstack/react-router'
import { usePageTitle } from '../../../features/page-title/pageTitle.ts'
import { LiveblogProfilesPage } from '../../../features/liveblog-profiles/LiveblogProfilesPage.tsx'

export const Route = createFileRoute('/me/_settings/liveblog-profiles')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Author profiles')
  return <LiveblogProfilesPage />
}
